/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbConfigDeleteResponse extends models.ServiceNowCmdbConfigBaseResponse {
    getFixupPrototypeFunction() { return ServiceNowCmdbConfigDeleteResponse.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbConfigDeleteResponse>): ServiceNowCmdbConfigDeleteResponse {
        let obj = Object.assign(new ServiceNowCmdbConfigDeleteResponse(), model);
        ServiceNowCmdbConfigDeleteResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbConfigDeleteResponse>): ServiceNowCmdbConfigDeleteResponse {
        if (!model) return null;
        return ServiceNowCmdbConfigDeleteResponse.newInstance(<ServiceNowCmdbConfigDeleteResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbConfigDeleteResponse) {
        if (!obj) return;

        models.ServiceNowCmdbConfigDeleteResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbConfigDeleteResponse): boolean {
        if (models.ServiceNowCmdbConfigBaseResponse.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceNowCmdbConfigDeleteResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
